<template>
	<div class="">
		<base-page-heading
			title="Country"
			subtitle=""
			class="d-print-none"
		/>

		<div class="row">
			<CountryTable @routeCountry="routeCountry" />
		</div>
	</div>
</template>
